import React, { useEffect, useRef, useState } from "react";
import styles from "./doubt.module.css";
import WelcomeClassifier from "../Classifier/WelcomeClassifier";
import PlainInput from "../Editor/PlainInput";
import { useDoubt } from "../../../context/DoubtContext";
import { useTutor } from "../../../context/AiTutorContext";
import ChatView from "../../../components/molecules/ai-tutor/ChatView/ChatView";
import LiveStreaming from "../../../components/molecules/ai-tutor/ChatView/LiveStreaming";
import {
  isEmptyOrNull,
  isNotEmptyOrNull,
  urlString } from
"../../../utils/common-utils";
import {
  BOTTOM_BUTTONS,
  getConcludeBtnText,
  OutOfContext,
  OutOfTopic } from
"../../../utils/TutorConstants";
import Assistant from "../../../components/molecules/ai-tutor/Assistant/Assistant";
import { useRoot } from "../../../context/RootContext";
import SummaryList from "./SummaryList";
import SummaryView from "./SummaryView";
import pkg from "@inrscr/coschool-ui-components";
import FeedbackModal from "../../../components/organisms/ai-tutor/FeedbackModal";
import { useMediaQuery } from "react-responsive";
import SummaryBottomSheet from "../../../components/organisms/ai-tutor/SummaryBottomSheet";
import { Box, Grid, Image, Text, useToast } from "@chakra-ui/react";
import PracticeMedia from "../Practice/PracticeMedia";
import { DoubtStyles } from "./DoubtStyles";
import { QuestionsLayout } from "../../../components/molecules/questionLayouts/QuestionsLayout";
import { useNavigate } from "@remix-run/react";
import DoubtKeyTakeAway from "../../../components/molecules/ai-tutor/DoubtKeyTakeAway";
import PocketModal from "./PocketModal";
import { StorageService } from "../../../utils/StorageUtils";
import { handleVideoEvent } from "../../../utils/common-utils";

const { MediaModal } = pkg;
const Doubt = (props) => {
  const isMobile = useMediaQuery({
    query: "(max-width: 768px)"
  });
  const toast = useToast();
  const divRef = useRef(null);
  const isUserScrolled = useRef(false);
  const {
    loader,
    classifierInfo,
    setIsDoubt,
    openFeedbackModal,
    setOpenFeedbackModal,
    setIsFeedbackSubmitted,
    curriculumObj,
    doubtQuestionObj
  } = useTutor();
  const {
    openDoubtSideMenu,
    toggleDoubtDrawer,
    isPlayground,
    isStandalone,
    setOpenDoubtSideMenu,
    pocketIconRef,
    setTaskType
  } = useRoot();
  const {
    streamingText,
    chatQuery,
    chatHistory,
    summaryInfo,
    handleContinueConv,
    handleSwitchTopic,
    handleShowSummary,
    handleSendToPocket,
    handleAskNewQuestion,
    buttons,
    handleDoubtFlow,
    summarySection,
    chatId,
    chatIndex,
    isOutOfTopic,
    setShowHintBtn,
    contextQuery,
    mediaDetails = [],
    assistantRefImages = [],
    isConvCompleted,
    selectedSummary,
    retrieveUserChat,
    setBackToSyllabus
  } = useDoubt();
  const { classifierStatus } = classifierInfo;
  const {
    feedback,
    selectAnotherTopic,
    continueConversation,
    anotherDoubt,
    sendToPocket,
    clarificationBtnText,
    seeConversation
  } = BOTTOM_BUTTONS;
  const { summary, showSummary, isSummaryCompleted } = summaryInfo;
  const { switchContext } = buttons;
  const [selectedMedia, setSelectedMedia] = useState({});
  const [openMedia, setOpenMedia] = useState(false);
  const [pocketModal, setPocketModal] = useState(false);

  const navigate = useNavigate();
  const { chat_uuid } = selectedSummary;
  const doubtSideMenuRef = useRef(null);

  useEffect(() => {
    setIsDoubt(true);
    setTaskType("");
  }, []);

  useEffect(() => {
    if (!isStandalone && !isNotEmptyOrNull(props?.subjectMasterUuid)) {
      // window.location.href = `${urlString}/syllabus`;
      setBackToSyllabus(true);
    }
  }, [props, isStandalone]);
  useEffect(() => {
    if (isOutOfTopic || switchContext) {
      setShowHintBtn(false);
    }
  }, [buttons]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
      doubtSideMenuRef?.current &&
      !doubtSideMenuRef?.current.contains(event.target) &&
      !pocketIconRef?.current?.contains(event?.target))
      {
        setOpenDoubtSideMenu(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [openDoubtSideMenu]);

  useEffect(() => {
    const container = divRef.current;
    const handleScroll = () => {
      const isAtBottom =
      Math.abs(
        container.scrollHeight - container.clientHeight - container.scrollTop
      ) <= 5;
      isUserScrolled.current = !isAtBottom;
    };

    container.addEventListener("scroll", handleScroll);

    if (!isUserScrolled.current) {
      requestAnimationFrame(() => {
        container.scrollTop = container.scrollHeight;
      });
    }

    return () => container.removeEventListener("scroll", handleScroll);
  }, [chatHistory, streamingText, chatQuery, summaryInfo]);

  const handleShowMedia = (item) => {
    setSelectedMedia({});
    setOpenMedia(true);
    setSelectedMedia(item);
  };

  const handleButtonActions = (action) => {
    switch (action) {
      case selectAnotherTopic:
        handleSwitchTopic();
        if (!isStandalone) {
          navigate(`${urlString}/syllabus`, { replace: true });
        }
        break;
      case continueConversation:
        handleContinueConv();
        break;
      case clarificationBtnText:
        handleContinueConv();
        break;
      case getConcludeBtnText(buttons?.doubtState):
        handleShowSummary();
        break;
      case feedback:
        setOpenFeedbackModal(true);
        break;
      case anotherDoubt:
        handleAskNewQuestion();
        break;
      case sendToPocket:
        setPocketModal(true);
        break;
      case seeConversation:
        retrieveUserChat(chat_uuid);
        break;
    }
  };

  const content = () => {
    return (
      <Box sx={DoubtStyles()?.doubtContainer}>
        <Box sx={DoubtStyles()?.subContainer}>
          <WelcomeClassifier
            subject={props?.subject}
            subjectMasterUuid={props?.subjectMasterUuid}
            topic={props?.topic}
            topicMasterUuid={props?.topicMasterUuid}
            subjectName={props?.subjectName}
            topicName={props?.topicName}
            chatId={chatId}
            showChatIcon={isPlayground && chatHistory?.length > 0} />

          {doubtQuestionObj?.version_uuid &&
          <Box pointerEvents={"none"} ml={"54px"}>
              <QuestionsLayout
              questionObject={doubtQuestionObj}
              onAnswerChanged={() => {}}
              isFactualBasket={false}
              isAnswerSubmitted={true}
              isUser={true} />

            </Box>
          }
          {chatHistory?.length > 0 &&
          <ChatView
            history={chatHistory}
            assistantRefImages={assistantRefImages} />

          }
          {classifierStatus !== 3 &&
          <LiveStreaming
            query={chatQuery}
            answer={streamingText}
            loader={loader}
            hideVin={true} />

          }
          {showSummary && !isEmptyOrNull(summary) &&
          <DoubtKeyTakeAway
            summary={summary}
            assistantRefImages={assistantRefImages}
            index={`${chatId}-summary`}
            isSummaryCompleted={isSummaryCompleted}
            chatId={chatId}
            chatIndex={chatIndex} />

          }
          {switchContext && <Assistant text={OutOfContext} />}
          {isOutOfTopic && <Assistant text={OutOfTopic} />}
        </Box>
      </Box>);

  };
  const contentStyle = {
    flex: 1,
    overflowX: "hidden"
  };
  const drawerStyle = `${styles["drawer"]} ${
  openDoubtSideMenu ? styles["drawer-open"] : ""}`;

  const mediaMenuStyle = `${styles["media-menu"]} ${
  mediaDetails?.length > 0 ? styles["drawer-open"] : ""}`;


  return (
    <div className={styles["doubt"]}>
      <div className={styles["content-container"]}>
        <div className={styles["content"]} ref={divRef} style={contentStyle}>
          {!summarySection ?
          content() :

          <SummaryView handleShowMedia={handleShowMedia} />
          }
        </div>
        {mediaDetails?.length > 0 && !isMobile &&
        <div className={mediaMenuStyle}>
            <PracticeMedia
            mediaDetails={mediaDetails}
            handleShowMedia={handleShowMedia} />

          </div>
        }
        {openDoubtSideMenu &&
        <div ref={doubtSideMenuRef} className={drawerStyle}>
            <div className={styles["my-pocket"]}>My Pocket</div>
            <SummaryList />
          </div>
        }
      </div>
      <div className={styles["bottom"]}>
        <PlainInput
          isDisable={
          !isNotEmptyOrNull(classifierInfo?.classifierHistory) ?
          true :
          switchContext || showSummary || isOutOfTopic || isConvCompleted
          }
          buttons={buttons}
          handleSubmit={handleDoubtFlow}
          chatHistory={chatHistory}
          handleButtonActionsInDoubt={handleButtonActions}
          resetPractice={() => {
            if (isStandalone) {
              window.location.reload();
            }
          }} />

      </div>
      {openMedia &&
      <MediaModal
        selectedMedia={selectedMedia}
        openMedia={openMedia}
        handleClose={() => {
          setOpenMedia(false);
        }}
        // Optional props for customization
        updateVideoEvents={handleVideoEvent}
        styles={styles}
        modalSize="3xl"
        modalZIndex={3500}
        videoAspectRatio={16 / 9}
        imageMaxHeight="360px"
        maxModalHeight="70vh"
        // iOS optimizations
        enableIOSOptimizations={true}
        osCloseDelay={300} />

      }
      {openFeedbackModal &&
      <FeedbackModal
        chatId={chatId}
        mode={"Doubt"}
        setIsFeedbackSubmitted={setIsFeedbackSubmitted}
        curriculumObj={curriculumObj} />

      }
      {pocketModal &&
      <PocketModal
        isOpen={pocketModal}
        handleClose={() => {
          setPocketModal(false);
        }}
        handleSubmit={(data) => {
          setPocketModal(false);
          handleSendToPocket(data);
        }}
        contextQuery={contextQuery} />

      }
    </div>);

};

export default React.memo(Doubt);